<ng-container *ngIf="noData">
	<section class="notes__no-data">
		<p>no data to show</p>
	</section>
</ng-container>
<ng-container *ngIf="!noData">
	<section class="notes">
		<ng-content select="app-quote-drawer-heading"></ng-content>
		<section class="notes__form">
			<div class="notes__group m--padded">
				<p class="notes__heading">Notes on Pet Parents and Pets</p>
				<div class="notes__control">
					<p class="notes__control-heading">Pet Parent: {{ contactFullName$ | async }}</p>
					<div>
						<label
							for="petParentNotes"
							class="c-native-label"
						>
							Pet Parent Notes
						</label>
						<mat-form-field class="c-important-notes notes__control-field">
							<textarea
								matInput
								[formControl]="petParentImportantNotes"
								name="petParentNotes"
								id="petParentNotes"
							></textarea>
						</mat-form-field>
					</div>
				</div>
			</div>
			<mat-divider></mat-divider>
			<div
				*ngFor="let pet of activePets$ | async; trackBy: trackFormChanges; let i = index"
				class="notes__group m--padded"
			>
				<div
					*ngIf="pet.name"
					class="notes__control"
				>
					<p class="notes__control-heading">Pet: {{ pet.name }}</p>
					<div>
						<label
							attr.for="petParentNotes{{ i }}"
							class="c-native-label"
						>
							Pet Notes
						</label>
						<mat-form-field class="notes__control-field">
							<!-- <mat-label>Pet Parent Notes</mat-label> -->
							<textarea
								#importantNotes
								matInput
								[value]="pet.importantNotes || ''"
								attr.name="petParentNotes{{ i }}"
								attr.id="petParentNotes{{ i }}"
								(input)="handlePetImportantNotesChange(importantNotes.value, pet.crmPetId)"
							></textarea>
						</mat-form-field>
					</div>
				</div>
			</div>
		</section>
	</section>
</ng-container>
